import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { Button } from "@mui/material";

interface Props {
  isPrivate: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const ShareButton = ({ isPrivate, disabled, onClick }: Props) => (
  <Button
    variant="outlined"
    color="secondary"
    startIcon={isPrivate ? <LockOutlinedIcon /> : <PeopleAltOutlinedIcon />}
    onClick={onClick}
    disabled={disabled}
  >
    Share
  </Button>
);

export default ShareButton;
